export const API_URL = import.meta.env.VITE_API_URL || 'http://localhost:3001';
export const AUTH_TOKEN_KEY = import.meta.env.VITE_AUTH_TOKEN_KEY || 'auth_token';
export const API_GATEWAY_URL = import.meta.env.VITE_API_GATEWAY_URL || 'http://localhost:3050/api';
// Shared Clock In / Clock Out widget bundle served by attendance-service (empty = off)
export const CLOCK_WIDGET_URL = import.meta.env.VITE_CLOCK_WIDGET_URL || '';
// Shared notifications bell + page (notifications-widget/, served at /widget) — empty = off
export const NOTIFICATIONS_WIDGET_URL = import.meta.env.VITE_NOTIFICATIONS_WIDGET_URL || '';
// WebSocket origin for live notifications (empty = same host)
export const AUTH_WS_URL = import.meta.env.VITE_AUTH_WS_URL || '';
